export function isFormValueCondition(condition) {
    if (Object.prototype.hasOwnProperty.call(condition, 'fieldName')) {
        return true;
    }
    return false;
}
